import componentInitializer from "@/frontend/utils/componentInitializer"
import asyncComponent from "@/frontend/utils/asyncComponent"
import Vue from "vue"
export * from "@/lib/vue/plugins/vueQuery"

componentInitializer(() => {
  let el = document.getElementById("vue-artist-profile-page")

  if (el) {
    const ArtistProfilePage = asyncComponent(() => import("@/pages/ArtistProfilePage/index.vue"), {
      label: "Fetching profile data…",
    })

    new Vue({
      el,
      render: (h) =>
        h(ArtistProfilePage, {
          props: {
            artist: JSON.parse(el.dataset.artist),
            sortOptions: JSON.parse(el.dataset.sortOptions),
            showPortfolio: JSON.parse(el.dataset.showPortfolio),
          },
        }),
    })
    // Workaround to avoid the page to scroll all the way down
    $(window).scrollTop(0)
  }
})
